export const rootFolderData: any = [
  {
    id: "01DXZKD2A5NSGBHNW3QNAAAA1212XQ7WYJLGFAVT",
    key: "01DXZKD2A5NSGBHN121W3QNA2XQ7WYJLGFAVT",
    createdDateTime: "2024-07-16T07:13:31Z",
    name: "TÀI LIỆU BÊN NGOÀI (thử nghiệm)",
    title: "TÀI LIỆU BÊN NGOÀI (thử nghiệm)",
    docPosition: 331,
    listId: "331",
    children: [],
  },
  {
    id: "01DXZKD2A5NSGBHNW3QNA2XQ7WYJLGFAAA",
    key: "01DXZKD2A5NSGBHNW3QNA2XQ7WYJLGFAAA",
    createdDateTime: "2024-07-16T07:13:31Z",
    name: "TÀI LIỆU VIAGS (thử nghiệm)",
    title: "TÀI LIỆU VIAGS (thử nghiệm)",
    docPosition: 331,
    listId: "331",
    children: [],
  },
  {
    id: "01DXZKD2A2M4AZRRALJJ2J54SKIOV4YQ42",
    key: "01DXZKD2A2M4AZRRALJJ2J54SKIOV4YQ42",
    createdDateTime: "2024-07-16T07:13:31Z",
    name: "TÀI LIỆU",
    title: "TÀI LIỆU",
    docPosition: 331,
    listId: "331",
    children: [
      {
        id: "01DXZKD2A5NSGBHNW3QNSAA2XQ7WYJLGFAVT",
        key: "01DXZKD2A5NSGBHNW3QSAA2XQ7WYJLGFAVT",
        createdDateTime: "2024-07-16T07:13:31Z",
        name: "TÀI LIỆU VIAGS",
        title: "TÀI LIỆU VIAGS",
        docPosition: 331,
        listId: "331",
        children: [],
      },
      {
        id: "01DXZKD2A5NSGBHNW3QNSAA2XQ7WYJ9kLGFAAA",
        key: "01DXZKD2A5NSGBHNW3QNSAASA2XQ7WYJ9kLGFAAA",
        createdDateTime: "2024-07-16T07:13:31Z",
        name: "TÀI LIỆU VIAGS BÊN NGOÀI",
        title: "TÀI LIỆU VIAGS BÊN NGOÀI",
        docPosition: 331,
        listId: "331",
        children: [],
      },
      {
        id: "01DXZKD2A5NSGBHNW3QNkkASSS2XQ7WYJLGFAVT",
        key: "01DXZKD2A5NSGBHNW3QNkkASASA2XQ7WYJLGFAVT",
        createdDateTime: "2024-07-16T07:13:31Z",
        name: "TÀI LIỆU CHI NHÁNH DAD",
        title: "TÀI LIỆU CHI NHÁNH DAD",
        docPosition: 331,
        listId: "331",
        children: [],
      },
      {
        id: "01DXZKD2A5NSGBHNW3QNA2XQ7WYABA1JLGFAAA",
        key: "1DXZKD2A5NSGBHNW3QNA2XQ7WYABA1JLGFAAA",
        createdDateTime: "2024-07-16T07:13:31Z",
        name: "TÀI LIỆU CHI NHÁNH NBA",
        title: "TÀI LIỆU CHI NHÁNH NBA",
        docPosition: 331,
        listId: "331",
        children: [],
      },
      {
        id: "01DXZKD2A5NSGBHNW3QNA2XQ7WYJLAZVAGFAVT",
        key: "1DXZKD2A5NSGBHNW3QNA2XQ7WYJLAZVAGFAVT",
        createdDateTime: "2024-07-16T07:13:31Z",
        name: "TÀI LIỆU CHI NHÁNH TSN",
        title: "TÀI LIỆU CHI NHÁNH TSN",
        docPosition: 331,
        listId: "331",
        children: [],
      },
      {
        id: "01DXZKD2A5NSGBHNW3QNA2XQ7WYJLsGFAAA",
        key: "01DXZKD2A5NSGBHNW3QNA2XQ7WYsJLGFAAA",

        createdDateTime: "2024-07-16T07:13:31Z",
        name: "TÀI LIỆU VIAGS",
        title: "TÀI LIỆU VIAGS",
        docPosition: 331,
        listId: "331",
        children: [],
      },
      {
        id: "01DXZKD2A5NSGBHNW3QNAAG122XQ7WGFAVT",
        key: "01DXZKD2A5NSGBHNW3QNAAG122XQ7WGFAVT",
        createdDateTime: "2024-07-16T07:13:31Z",
        name: "TÀI LIỆU BÊN NGOÀI (thử nghiệm)",
        title: "TÀI LIỆU BÊN NGOÀI (thử nghiệm)",
        docPosition: 331,
        listId: "331",
        children: [],
      },
      {
        id: "01DXZKD2A5NAASaGBHNW3QaFNA2XWYJLGFAAA",
        key: "01DXZKD2A5NaAASGBHN21W3QFNA2XWYJLGFAAA",
        createdDateTime: "2024-07-16T07:13:31Z",
        name: "THƯ VIỆN AN TOAN - AN NINH",
        title: "THƯ VIỆN AN TOAN - AN NINH",
        docPosition: 331,
        listId: "331",
        children: [],
      },
    ],
  },
];
